export const env = () => (process.env.REACT_APP_ENV)

export const domain = (key) => {
    const loc = window.location.pathname
    const subdir = loc.split('/')[1]
    const list = {
        tool: {
            url: subdir === 'biz' ? process.env.REACT_APP_URL_TOOL_BIZ : process.env.REACT_APP_URL_TOOL_PSL,
            ws: process.env.REACT_APP_WS_URL,
            biz: process.env.REACT_APP_SP_URL_BIZ,
            psl: process.env.REACT_APP_SP_URL_PSL
        },
        pm: {
            url: process.env.REACT_APP_URL_PM,
            ws: process.env.REACT_APP_WS_URL_PM
        },
        psl: {
            url: process.env.REACT_APP_URL_PSL,
            ws: process.env.REACT_APP_WS_URL_PSL
        },
        biz: {
            url: process.env.REACT_APP_URL_BIZ,
            ws: process.env.REACT_APP_WS_URL_BIZ
        },
        api: {
            tool: process.env.REACT_APP_API_URL_TOOL,
            global: process.env.REACT_APP_API_URL_GLOBAL,
            notif: process.env.REACT_APP_API_URL_NOTIF,
            psl: process.env.REACT_APP_API_URL_PSL,
        },
        mp: {
            url: process.env.REACT_APP_URL_MP,
        },
    }

    return list[key]
}

export const key = (key) => {
    const loc = window.location.pathname
    const subdir = loc.split('/')[1]
    const list = {
        gapi_key: process.env.REACT_APP_POF_GLOBAL_API_KEY,
        tapi_key: subdir === 'biz' ? process.env.REACT_APP_TOOL_API_KEY_BIZ : process.env.REACT_APP_TOOL_API_KEY_PSL,
        aui_key: subdir === 'biz' ? process.env.REACT_APP_AUI_KEY_BIZ : process.env.REACT_APP_AUI_KEY_PSL,
        tsa_key: subdir === 'biz' ? process.env.REACT_APP_TSA_KEY_BIZ : process.env.REACT_APP_TSA_KEY_PSL,
        tid: subdir === 'biz' ? process.env.REACT_APP_TID_BIZ : process.env.REACT_APP_TID
    }

    return list[key]
}

export const aws = (key) => {
    const list = {
        secret_key: process.env.REACT_APP_AWSS3_SECRET_ACCESS_KEY,
        access_key: process.env.REACT_APP_AWSS3_ACCESS_KEY_ID,
        bucket_name: process.env.REACT_APP_AWSS3_BUCKET_NAME,
        region: process.env.REACT_APP_AWSS3_REGION,
    }

    return list[key]
} 